export class DomainService {
  static extractDomain(email: string): string {
    const parts = email.toLowerCase().split('@');
    return parts.length === 2 ? parts[1] : '';
  }

  static validateEmailDomain(email: string, allowedDomain: string): boolean {
    const emailDomain = this.extractDomain(email);
    return emailDomain === allowedDomain.toLowerCase();
  }

  static validateSameDomain(email1: string, email2: string): boolean {
    return this.extractDomain(email1) === this.extractDomain(email2);
  }

  static isPublicEmailDomain(email: string): boolean {
    const publicDomains = [
      'gmail.com',
      'yahoo.com',
      'hotmail.com',
      'outlook.com',
      'aol.com',
      'icloud.com',
      'mail.com',
      'protonmail.com',
      'yandex.com',
      'zoho.com'
    ];
    
    const domain = this.extractDomain(email);
    return publicDomains.includes(domain);
  }

  static async verifyDomainOwnership(email: string, verificationEmail: string): Promise<boolean> {
    // Ensure both emails are from the same domain
    if (!this.validateSameDomain(email, verificationEmail)) {
      throw new Error('Email domain does not match verification domain');
    }

    // Ensure it's not a public email domain
    if (this.isPublicEmailDomain(email)) {
      throw new Error('Public email domains are not allowed for organization setup');
    }

    return true;
  }
}

export default DomainService;